import tinycolor2 from 'tinycolor2';

export const getColor = color => tinycolor2(color);

// WCAG 2.x contrast ratio between two colors (1 to 21).
export const getContrastRatio = (color1, color2) => tinycolor2.readability(color1, color2);

export const getRandomColor = () => tinycolor2.random();

export const isLightColor = color => tinycolor2(color).isLight();

export const isDarkColor = color => tinycolor2(color).isDark();

export const isValidColor = color => tinycolor2(color).isValid();

export const isWhiteColor = color => tinycolor2(color).toHexString().toLowerCase() === '#ffffff';
